/* eslint-disable  @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable  @typescript-eslint/explicit-function-return-type */
import { HordeMembers } from '../../../components/SwapKiwi/HordeMembers';
import { PageHeader } from '../../../components/SwapKiwi/PageHeader';
import { SupportersContainer } from '../../../components/SwapKiwi/SupportersContainer';
import { TextWithImage, BackgroundColor, ImagePosition } from '../../../components/SwapKiwi/TextWithImage';

import { ReactComponent as EthReloadKiwi } from '../../../assets/svg/icons/eth-reload-kiwi.svg';
import { ReactComponent as MascotRun } from '../../../assets/svg/icons/Kiwi_About.svg';

import aalduz from '../../../assets/jpg/aalduz.jpg';
import akimovv from '../../../assets/jpg/akimovv.jpg';
import stefann from '../../../assets/jpg/stefann.jpg';
import atila from '../../../assets/jpg/atila.jpg';
import facuserif from '../../../assets/jpg/facuserif.jpg';
import niftynaut from '../../../assets/jpg/niftynaut.jpg';

import animoca from '../../../assets/svg/supporters/animoca.svg';
import delta from '../../../assets/svg/supporters/delta.svg';

export const components = [
  {
    name: PageHeader,
    props: {
      background: 'grape-500',
      title: 'About Us',
      description:
        '<p class="text-lg text-cloud-900">The purpose of swap.kiwi is simple: <br> having a trusted tool at hand that allows you to swap NFTs with others.</p>',
      sticker: EthReloadKiwi,
      stickerWidth: 257,
      breadcrumbs: {
        links: [
          {
            label: 'Home',
            slug: '/',
          },
          {
            label: 'About Us',
            slug: '/about-us',
          },
        ],
      },
      notTopBorder: true,
    },
  },
  {
    name: TextWithImage,
    props: {
      background: BackgroundColor.LEMON,
      imagePosition: ImagePosition.LEFT,
      content:
        "<div><h4 class='text-display-md text-cloud-900 mb-2.25'>Do it your way</h4><p class='text-lg text-cloud-900 mb-8.75'>Control over your NFTs stays in your hands. We give you the power to do, the freedom to decide how, when and what to swap.<br />With kiwi you have peace of mind so you can have fun and enjoy your swaps. We will take care of the rest, so you don’t have to worry. We remove obstacles so you have a solution at hand that adapts to your needs.</p><h4 class='text-display-md text-cloud-900 mb-2.25'>Niftyhorde</h4><p class='text-lg text-cloud-900'><strong>swap.kiwi</strong> is being built by the awesome team behind <strong>niftyhorde</strong>, a <em>blockchain-based creative think tank</em> which creates services and products for <strong>web3</strong>.</p></div>",
      image: MascotRun,
    },
  },
  {
    name: HordeMembers,
    props: {
      title: 'The Horde',
      description:
        'We have been in this space for some time, and with our talent and experience, we design and develop the tools you need to swap your most precious assets in a safe and scam-free environment.',
      members: [
        {
          name: '@Niftynaut',
          role: 'Imagineer',
          imageURL: niftynaut,
        },
        {
          name: '@aalduz',
          role: 'Elderiest Developer',
          imageURL: aalduz,
        },
        {
          name: '@facuserif',
          role: 'Crazy Designer',
          imageURL: facuserif,
        },
        {
          name: '@stefann',
          role: 'Mid-age Sporty Developer',
          imageURL: stefann,
        },
        {
          name: '@atila',
          role: 'Backend`s best friend',
          imageURL: atila,
        },
        {
          name: '@akimovv',
          role: 'Youngster',
          imageURL: akimovv,
        },
      ],
    },
  },
  {
    name: SupportersContainer,
    props: {
      title: 'Our supporters',
      description:
        'We met some awesome people along the way, who believe in us, trust our vision, and experience in the NFT market. They helped us to turn swap.kiwi into a full-time project. Below are some of them: thank you for your support 💛',
      supporters: [
        {
          name: 'Animoca',
          imageURL: animoca,
        },
        {
          name: 'Delta Fund',
          imageURL: delta,
        },
      ],
    },
  },
];
